<div class="log-viewer">

  <div class="filter-row">
    <mat-form-field appearance="outline">
      <mat-label>Date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" [(ngModel)]="rangeStart">
        <input matEndDate placeholder="End date" [(ngModel)]="rangeEnd">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Transaction ID</mat-label>
      <input matInput [(ngModel)]="transactionId" (keyup.enter)="search()" placeholder="Gateway transaction ID">
    </mat-form-field>

    <button mat-flat-button color="primary" (click)="search()">
      <mat-icon>search</mat-icon> Search
    </button>
  </div>

  @if (loading) { <mat-progress-bar mode="indeterminate"></mat-progress-bar> }

  @if (!loading && logs.length === 0) {
    <p class="empty">No gateway communication logged for this range.</p>
  }

  @if (logs.length > 0) {
    <table mat-table [dataSource]="logs" multiTemplateDataRows class="log-table">
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Time</th>
        <td mat-cell *matCellDef="let row">{{ row.createdAt | date:'MM/dd/yyyy h:mm a' }}</td>
      </ng-container>

      <ng-container matColumnDef="processorEnv">
        <th mat-header-cell *matHeaderCellDef>Processor / Env</th>
        <td mat-cell *matCellDef="let row">{{ row.processor }} / {{ row.environment }}</td>
      </ng-container>

      <ng-container matColumnDef="endpoint">
        <th mat-header-cell *matHeaderCellDef>Endpoint</th>
        <td mat-cell *matCellDef="let row">{{ row.endpoint }}</td>
      </ng-container>

      <ng-container matColumnDef="direction">
        <th mat-header-cell *matHeaderCellDef>Direction</th>
        <td mat-cell *matCellDef="let row">{{ row.direction }}</td>
      </ng-container>

      <ng-container matColumnDef="httpStatus">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">{{ row.httpStatus ?? '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="latencyMs">
        <th mat-header-cell *matHeaderCellDef>Latency (ms)</th>
        <td mat-cell *matCellDef="let row">{{ row.latencyMs ?? '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="gatewayTransactionId">
        <th mat-header-cell *matHeaderCellDef>Txn ID</th>
        <td mat-cell *matCellDef="let row">{{ row.gatewayTransactionId ?? '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="actor">
        <th mat-header-cell *matHeaderCellDef>Actor</th>
        <td mat-cell *matCellDef="let row">{{ row.actor ?? '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let row" [attr.colspan]="cols.length">
          <div class="detail-panel">
            <div class="detail-block">
              <strong>Request</strong>
              <pre>{{ prettyJson(row.requestBody) }}</pre>
            </div>
            <div class="detail-block">
              <strong>Response</strong>
              <pre>{{ prettyJson(row.responseBody) }}</pre>
            </div>
            @if (row.errorMessage) {
              <div class="detail-block">
                <strong>Error</strong>
                <pre>{{ row.errorMessage }}</pre>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="cols"></tr>
      <tr mat-row *matRowDef="let row; columns: cols;" class="log-row" (click)="toggleRow(row)"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpanded" class="detail-row"></tr>
    </table>

    <mat-paginator
      [length]="totalElements"
      [pageIndex]="page"
      [pageSize]="size"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPage($event)">
    </mat-paginator>
  }

</div>
